export default __webpack_public_path__ + "static/media/entry-gate-2400x1350.8c47f549.jpg";